import type { CSSProperties } from "react";
import { STORY_LAYERS } from "./story-geometry";
import styles from "./twin-story.module.css";

export function StoryParticles({ stage = 1, selected = -1, label = "The Twin’s six concentric colour layers" }: {
  stage?: number; selected?: number; label?: string;
}) {
  return <svg className={styles.particles} viewBox="0 0 1000 600" role="img" aria-label={label}>
    {STORY_LAYERS.map((layer, i) => {
      // The stage's shape is the path's own data as well as its CSS shape (.particlePath moves the dots between shapes): Safari takes no shape from CSS, and with the data left at one shape it drew that one at every stage.
      const shape = stage === 0 ? layer.scattered : stage === 2 ? layer.answer : layer.held;
      return <g key={layer.color} className={styles.particleLayer}
        style={{ opacity: selected < 0 || selected === i ? 1 : .12 }}>
        <path fill={layer.color} d={shape} className={styles.particlePath}
          style={{ "--shape": `path('${shape}')`, "--delay": `${i * 32}ms` } as CSSProperties} />
      </g>;
    })}
  </svg>;
}
